import React, { useState, useEffect } from 'react';
import CaseStudies from './pages/CaseStudies';
import { motion, AnimatePresence } from 'framer-motion';
import Contact from './pages/Contact';
import Skills from './pages/Skills';
import Certifications from './pages/Certifications';
import Gallery from './pages/Gallery';
import Resources from './pages/Resources';
import AboutMe from './pages/AboutMe';
import TableauEmbed from './pages/TableauEmbed';
import CareerTimeline from './pages/CareerTimeline';
import LoadingPulse from './pages/LoadingPulse';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin, faGithub, faHackerrank } from '@fortawesome/free-brands-svg-icons';

import './App.css';

const LOGGING_ENDPOINT = 'https://aibycode.vercel.app/api/log-visitor';

const pageTransition = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.5, ease: 'easeOut' },
};

function App() {
  const [page, setPage] = useState('home');
  const [menuOpen, setMenuOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetch('https://ipapi.co/json/')
      .then(res => res.json())
      .then(data => {
        const locationInfo = `${data.city}, ${data.region}, ${data.country_name} (${data.ip})`;
        fetch(LOGGING_ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ location: locationInfo }),
        })
          .then(res => res.json())
          .then(data => console.log('Visitor logged:', data))
          .catch(err => console.error('Logging error:', err));
      })
      .catch(err => {
        console.error('Location fetch failed:', err);
      });
  }, []);

  const handlePageChange = (newPage) => {
    setMenuOpen(false);
    setLoading(true);
    setTimeout(() => {
      setPage(newPage);
      setLoading(false);
    }, 1000);
  };

  return (
    <div className="container">
      <nav className="navbar">
        <div
          className="logo"
          onClick={() => handlePageChange('home')}
          title="Go to Home"
        >
          {/* <img src="/favicon.ico" alt="AR Logo" className="logo-image" /> */}
        </div>

        <button
          className="hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle Menu"
        >
          <FontAwesomeIcon icon={faBars} size="lg" />
        </button>
      <span className="brand-label">ArunAI.dev - Build & Automate</span>
      </nav>

      <div className={`nav-links ${menuOpen ? 'open' : ''}`}>
        <button onClick={() => handlePageChange('home')}>Home</button>
        <button onClick={() => handlePageChange('aboutme')}>About Me</button>
        <button onClick={() => handlePageChange('career')}>Career Timeline</button>
        <button onClick={() => handlePageChange('CaseStudies')}>Case Studies</button>
        <button onClick={() => handlePageChange('Gallery')}>Gallery</button>
        <button onClick={() => handlePageChange('Certifications')}>Certifications</button>
        <button onClick={() => handlePageChange('Skills')}>Skills</button>
        <button onClick={() => handlePageChange('Resources')}>Resources</button>
        <button onClick={() => handlePageChange('contact')}>Contact</button>
      </div>

      <AnimatePresence>
        {loading && (
          <motion.div
            key="loading-pulse"
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.8 }}
            exit={{ opacity: 0 }}
            style={{
              position: 'fixed',
              top: 0, left: 0, right: 0, bottom: 0,
              backgroundColor: 'rgba(0,0,0,0.6)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 9999,
            }}
          >
            <LoadingPulse />
          </motion.div>
        )}
      </AnimatePresence>

      <main style={{ filter: loading ? 'blur(3px) brightness(0.7)' : 'none', pointerEvents: loading ? 'none' : 'auto' }}>
        {!loading && (
          <>
            {page === 'home' && (
              <motion.div {...pageTransition}>
                <div className="home-content">
                  <div className="hero-section">
                    <div className="hero-text-with-image" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                      <img
                        src="/Arun_Profile_Image.jpeg"
                        alt="Profile"
                        style={{
                          width: '200px',
                          height: '200px',
                          borderRadius: '50%',
                          objectFit: 'cover',
                          marginRight: '1.5rem',
                          boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
                          borderRadius: '8px',
                          marginRight: '1.5rem',
                        }}
                      />

                      <div style={{ flex: '1' }}>
                        <motion.div style={{ marginTop: "0.5rem" }}>
                          <h3
                            style={{
                              fontSize: "2rem",
                              fontWeight: "700",
                              position: "relative",
                              display: "inline-block",
                              color: "#222",
                              marginBottom: "0.3rem",
                              cursor: "default",
                            }}
                          >
                            Arun Ramachandran,{" "}
                            <span
                              style={{
                                fontWeight: "500",
                                fontSize: "1.2rem",
                                color: "#555",
                                display: "block",
                                marginTop: "0.15rem",
                                letterSpacing: "0.04em",
                                fontStyle: "italic",
                              }}
                            >
                              Software Automation Enginneer at Inari Medical Inc | BTech & M.Sc Mechanical Engineering
                            </span>
                            <motion.span
                              layoutId="underline"
                              style={{
                                position: "absolute",
                                left: 0,
                                bottom: -6,
                                height: 3,
                                width: "100%",
                                backgroundColor: "#007bff",
                                borderRadius: 2,
                              }}
                              initial={{ width: 0 }}
                              animate={{ width: "100%" }}
                              transition={{ duration: 0.8, delay: 0.3 }}
                            />
                          </h3>

                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "0.7rem",
                              marginTop: "0.8rem",
                            }}
                          >
                            {[
                              "Certified Tableau Desktop Specialist",
                              "Software Automation Engineer",
                              "Selenium & Python Expert",
                              "Data Science",
                              "Robotics",
                              "Machine Learning & AI Enthusiast",
                            ].map((skill, i) => (
                              <span
                                key={i}
                                style={{
                                  backgroundColor: "#e3f2fd",
                                  color: "#0d47a1",
                                  padding: "6px 12px",
                                  borderRadius: "16px",
                                  fontSize: "0.9rem",
                                  fontWeight: "600",
                                  userSelect: "none",
                                  boxShadow:
                                    "0 1px 3px rgba(0,0,0,0.1), inset 0 1px 0 rgba(255,255,255,0.7)",
                                }}
                              >
                                {skill}
                              </span>
                            ))}
                          </div>
                        </motion.div>
                      </div>
                    </div>
                    <p
                      style={{
                        marginTop: "1rem",
                        fontSize: "1.1rem",
                        color: "#444",
                        fontStyle: "italic",
                        fontWeight: "500",
                        lineHeight: "1.4",
                      }}
                    > Showcasing my journey and passion for software development, AI, and automation. Explore my website to dive deeper into my work and interests.
                    </p>

                    <h1>Building Robust Software, One Line at a Time...</h1>

                    <img
                      className="hero-image"
                      src="https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&w=800&q=80"
                      alt="AI themed"
                    />
                  </div>

                  <section className="section-card ai-interest">
                    <h2>AI Meets Astronomy</h2>
                    <p>
                      This interactive tableau dashboard I have created, demonstrates how AI can be used to interpret complex astronomical data.
                      Used NASA exoplanet data to visualize trends and patterns in planetary discoveries:
                    </p>
                    <ul>
                      <li><strong>Exoplanet Discoveries Over the Years</strong>: A line chart showing how planetary discoveries have increased over time.</li>
                      <li><strong>Discovery Method Distribution</strong>: A pie chart breaking down which methods (e.g., transit, radial velocity) were used most frequently.</li>
                    </ul>
                    <p>
                      AI can be instrumental in analyzing vast space data, filtering signal from noise, and uncovering new celestial bodies.
                    </p>
                    <TableauEmbed />
                  </section>

                  <section className="section-card ai-interest">
                    <h2>My Passion and Focus</h2>
                    <p>
                      AI fascinates me because of its potential to transform industries and improve lives.
                      I am particularly interested in natural language processing and computer vision.
                    </p>
                  </section>

                  <section className="section-card future-projects">
                    <h2>Topics that interest me</h2>
                    <ul>
                      <li>Developing a chatbot using NLP techniques</li>
                      <li>Creating a computer vision application for image recognition</li>
                      <li>Exploring reinforcement learning algorithms</li>
                      <li>Self driving - Autonomous Vehicles</li>
                    </ul>
                  </section>
                </div>
              </motion.div>
            )}

            {page === 'CaseStudies' && <motion.div {...pageTransition}><CaseStudies /></motion.div>}
            {page === 'contact' && <motion.div {...pageTransition}><Contact /></motion.div>}
            {page === 'Skills' && <motion.div {...pageTransition}><Skills /></motion.div>}
            {page === 'Certifications' && <motion.div {...pageTransition}><Certifications /></motion.div>}
            {page === 'Gallery' && <motion.div {...pageTransition}><Gallery /></motion.div>}
            {page === 'Resources' && <motion.div {...pageTransition}><Resources /></motion.div>}
            {page === 'aboutme' && <motion.div {...pageTransition}><AboutMe /></motion.div>}
            {page === 'career' && <motion.div {...pageTransition}><CareerTimeline /></motion.div>}
          </>
        )}
      </main>

      <footer className="footer">
        <p>© 2025 Arun Ramachandran</p>
        <div className="footer-icons">
          <a href="https://www.linkedin.com/in/arun-ramachandran-a2019a/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <FontAwesomeIcon icon={faLinkedin} size="lg" />
          </a>
          <a href="https://github.com/Arun-K-Ram" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
            <FontAwesomeIcon icon={faGithub} size="lg" />
          </a>
          <a href="https://leetcode.com/u/Arun_Ram/" target="_blank" rel="noopener noreferrer" aria-label="HackerRank">
            <FontAwesomeIcon icon={faHackerrank} size="lg" />
          </a>
        </div>
      </footer>
    </div>
  );
}

export default App;
